import { GenericBlock } from '@app/components/pages/block/GenericBlock';
import { CmsGroups } from '@typings';

import styles from './BlockGroup.module.scss';
import { GroupContextProvider } from './GroupContext';
import { GroupGrid } from './GroupGrid';

export const BlockGroup = ({ group, section }: CmsGroups.GroupProps) => {
  return (
    <div className={styles.groupWrapper}>
      <GroupContextProvider groupId={group.id} sectionId={section.id}>
        <GroupGrid blocks={group.blocks} groupId={group.id}>
          {group.blocks.map(block => (
            <GenericBlock key={block.id} section={section} block={block} />
          ))}
        </GroupGrid>
      </GroupContextProvider>
    </div>
  );
};
